import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogComponent } from './blog.component';
import { SingleBlogComponent } from './single-blog/single-blog.component';
import { BlogRoutingModule } from './blog-routing.module';
import { BlogCardComponent } from './blog-card/blog-card.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { FaIconModule } from '../shared/modules/fa-icon/fa-icon.module';
import { MailingListModule } from '../mailing-list/mailing-list.module';


@NgModule({
  declarations: [
    BlogComponent,
    SingleBlogComponent,
    BlogCardComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    FaIconModule,
    BlogRoutingModule,
    MailingListModule
  ]
})
export class BlogModule { }
